<template>
  <div class="template-index" :style="getBgImg(eventInfo)">
    <div class="template-title">
      <!-- 比赛主数据 -->
      <img v-if="eventInfo.keyView" class="logo" :src="eventInfo.keyView" />

      <!-- 活动主标题 -->
      <h1 v-for="title in eventInfo.eventTitle.split('\n')" :key="title">{{ $t(title) }}</h1>

      <!-- 活动副标题 -->
      <h2 v-for="title in eventInfo.subTitle.split('\n')" :key="title">{{ $t(title) }}</h2>
      
    </div>

    <div class="btn btnlist">
      <el-tooltip :content='$t(link.tips)' placement="top" v-for="link in eventInfo.mainLinks" :key="link.id">
        <button v-if="link.channel" :class=link.class @click='toLogin(link.channel)'>
          {{ $t(link.name) }}
        </button>
        <button v-else-if="link.path" :class=link.class @click='toPath(link.path)'>
          {{ $t(link.name) }}
        </button>
        <button v-else-if="link.href" :class=link.class @click='toHref(link.href)'>
          {{ $t(link.name) }}
        </button>
        <button v-else :class=link.class>
          {{ $t(link.name) }}
        </button>
      </el-tooltip>

      <el-tooltip v-if="eventInfo.signUpBtn" :content='$t("Account_Register_Tip")' placement="top">
        <button class="raise2" @click="toSignup">{{$t("Account_Register")}}</button>
      </el-tooltip>

      <el-tooltip v-if="eventInfo.startBtn" :content='$t("Start_Event_Tip")' placement="top">
        <button class="raise" @click="toLogin(eventInfo.channel)">{{ $t("Start_Event") }}</button>
      </el-tooltip>

    </div>


    <div class="support">
      <div class="center">
        <div v-for="(item, index) in eventInfo.orgList" :key="index" class="left">
          <div v-for="(v, k) in item" :key="k" class="left">
            <span><b>{{ $t(k) }}</b>：</span>
            <div class="column">
              <span v-for="(j, i) in v" :key="i">{{ $t(j) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 联系人二维码 -->
      <div v-if="eventInfo.qrcode" class="qrcode">
        <img :src ="`https://c.icode.org.cn/contests/qrcode/${eventInfo.qrcode}`" />
        <p>{{ $t("Event_Contact") }}</p>
      </div>
    </div>

  </div>
</template>

<script>

import '@/components/contest/assets/css/template.scss';
import { getBgImg, parseEventInfo } from '@/components/contest/template/event';

export default {
  props:['eventInfo'],
  data() {
    return {
      getBgImg: getBgImg,
      // QRList: EventInfo.QRList,
    };
    
  },
  created() {
    this.checkServerTime();
    let channel = this.$route.params['channel'];

    if(channel != this.eventInfo.channel) {
      this.getEventInfo({channel: "cngef_" + channel});
    }
  },

  methods: {
    toHref(href) {
      window.location.href = href;
    },
    toPath(path) {
      window.location.href = window.location.origin + path;
    },
    toLogin(channel) {
      if(channel == this.eventInfo.channel && this.eventInfo.status != 1) {
        this.$notify.error({
          title: this.$t("Event_Ended"),
          message: this.$t("Event_Ended_Message")
        });
        return;
      }

      if(!channel) return;

      this.$router.push({path: "/"+ (channel || this.eventInfo.channel) + "/login"});
    },

    toSignup() {
      if(this.eventInfo.status != 1) {
        this.$notify.error({
          title: this.$t("Event_Ended"),
          message: this.$t("Event_Ended_Message")
        });
        return;
      }

      this.$router.push({
        path: "/"+ this.eventInfo.channel + "/signup",
      });
    },

    async checkServerTime() {
      try {
        await this.$http
          .getAxios(`foo/getTime`, {
            method: "get",
          })
          .then((res) => {

            if (res.status == 200) {
              let timeGap = Math.abs(new Date().getTime() / 1000 - res.data);
              if(timeGap > 300){ // 5分钟以上提示
                this.$notify.error({
                  title: this.$t("Time_Not_Sync"),
                  message: this.$t("Time_Not_Sync_Message")
                });      
              }

            } else {
              this.$notify.error({
                title: this.$t("Unable to connect to the server"),
                message: this.$t("Unable to connect to the server. Please check if your network is working properly."),
              });
            }
          });
      } catch (e) {
        console.log(e);
      }
    },

    async getEventInfo(params) {
      try {
        await this.$http
          .getAxios(`event/getEvent`, {
            method: "get",
            params: params,
          })
          .then((res) => {
            const _res = res.data;

            if (_res.code == 0) {

              Object.assign(this.eventInfo, _res.data);
              parseEventInfo(this.eventInfo);

            } else {
              this.$notify.error({
                title: this.$t("Event_Not_Ready"),
                message: this.$t("Event_Not_Ready_Message"),
              });
            }

          });
      } catch (e) {
        console.log(e);
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/contest/cngef/template/index.vue